module.exports = __webpack_public_path__ + "img/logo.986f4829.png";